<template>
  <b-img src="@/assets/logos/iaqfaz-logo.png" width="300"></b-img>
</template>

<script>
import { BImg } from 'bootstrap-vue'
export default {
  name: 'LogoIaqfaz',
  components: {
    BImg,
  },
}

</script>

<style scoped>
  svg {
    width: 100%;
  }
</style>
